import {Component, OnInit, AfterViewInit} from '@angular/core';
import {StepComponent} from "../../step/step.component";
import {StepService} from "../../services/step.service";
import {Router} from "@angular/router";
import {ElementService} from "../../services/element.service";
import {PortalService} from "../../services/portal.service";
import {HeizcheckRequestService} from "../services/heizcheck-request.service";
import {HeizcheckAnfrage} from "../anfrage/heizcheck.anfrage";

/**
 * Special component for the step to stop the advisor because we can not offer anything to the user
 */
@Component({
    selector: 'app-heizkostenabrechnung-ausstieg',
    templateUrl: './heizkostenabrechnung.ausstieg.component.html',
    standalone: false
})
export class HeizkostenabrechnungAusstiegComponent extends StepComponent implements OnInit, AfterViewInit {

  /**
   * (input) data of the user
   */
  anfrage: HeizcheckAnfrage;

  /**
   * The last step were we should navigate with the back button to.
   */
  lastStep: string = "../../heizkostenabrechnung/start";

  /**
   * define the case why we stop here.
   */
  case: string = null;

  /**
   * Overwrite the label prefix.
   */
  textkeyPrefix: string = "heizcheck";

  /**
   *
   * @param stepService
   * @param router
   * @param elementService
   * @param portalService
   * @param requestService
   */
  constructor(protected stepService: StepService, protected router: Router, protected elementService: ElementService, protected portalService: PortalService,
              protected requestService: HeizcheckRequestService) {
    super(stepService, router, elementService);
  }

  /**
   * @inheritDoc
   */
  ngOnInit() {
    super.ngOnInit();

    // get the input data
    this.anfrage = this.requestService.getAnfrage();

    // check if there is a last step given were we should navigate in case of the backstep to
    if(history?.state?.lastStep) {
      this.lastStep = history.state.lastStep;
    }

    if(this.anfrage.heizkostenanalyseInput?.prozent_grundkosten_raumwaerme === 100 || this.anfrage.heizkostenanalyseInput?.prozent_grundkosten_warmwasser === 100) {
      this.case = 'grundkosten';
    }
    if (this.anfrage.heizkostenanalyseInput?.nutzergruppen === 'ja') {
      this.case = 'nutzergruppen';
    }
    if(this.anfrage.heizkostenanalyseInput?.nutzungszeitraum === 'ja') {
      this.case = 'nutzungszeitraum';
    }
  }

  /**
   * @inheritDoc
   */
  ngAfterViewInit(): void {
    super.ngAfterViewInit();

    // scroll to the top
    const element = document.querySelector("body");
    this.elementService.scrollToElement(element)
  }
}
